// extracted by mini-css-extract-plugin
export var cta_block = "index-module--cta_block--QqNyu";
export var cta_container = "index-module--cta_container--ZwNO2";